import { render, staticRenderFns } from "./ProductInventoryFormer.vue?vue&type=template&id=09a967df&"
import script from "./ProductInventoryFormer.vue?vue&type=script&lang=js&"
export * from "./ProductInventoryFormer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports